import { ExpressionBuilder } from '../api';

const VARIABLE_PREFIX = '#';
const ROOT_VARIABLE_PREFIX = '#root.';

class SpELExpressionBuilder implements ExpressionBuilder {
  indexReplacement = (idxVar: string): string => `${VARIABLE_PREFIX}${idxVar}`;

  resolveAttributePath = (attribute: string): string => attribute;

  sizeOf(attribute: string): string {
    const rootAttribute = attribute.startsWith(ROOT_VARIABLE_PREFIX) ? attribute : ROOT_VARIABLE_PREFIX + attribute;
    return `#custCollectionFunc.size(${rootAttribute})`;
  }
}

const spelExpressionBuilder = new SpELExpressionBuilder();

export default spelExpressionBuilder;
